'use es6';

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GeneralInfoCardList = ({
  children,
  listCategoryKey,
  listPaddingInlineStart,
  toolTip,
  styled = false,
  expandable = false
}) => {
  const renderedList = useMemo(() => {
    return children ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      paddingBlockStart: "0",
      paddingBlockEnd: expandable ? '0' : '700',
      children: [/*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginBlockEnd: "200",
          display: "inline",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `ecosystem-marketplace-solutions-ui.profile.general.${listCategoryKey}`
          })
        }), toolTip && toolTip]
      }), /*#__PURE__*/_jsx(List, {
        marginBlockEnd: "0",
        paddingInlineStart: listPaddingInlineStart,
        styled: styled,
        children: children
      })]
    }) : null;
  }, [children, expandable, listCategoryKey, listPaddingInlineStart, styled, toolTip]);
  return expandable ? /*#__PURE__*/_jsx(CardSection, {
    paddingInline: "0",
    paddingBlockStart: "0",
    paddingBlockEnd: "400",
    children: /*#__PURE__*/_jsx(ExpandableText, {
      buttonAlign: "left",
      hideButtonCaret: true,
      maxHeight: 144,
      children: renderedList
    })
  }) : renderedList;
};
GeneralInfoCardList.propTypes = {
  children: PropTypes.node,
  listCategoryKey: PropTypes.string.isRequired,
  listClassNames: PropTypes.string,
  toolTip: PropTypes.element,
  styled: PropTypes.bool,
  expandable: PropTypes.bool
};
export default GeneralInfoCardList;